import { getCustomTrackingId } from '../../../analytics-library/getCustomTrackingId/getCustomTrackingId';
import { getRewrittenUrl } from '../../../analytics-library/getRewrittenUrl';
import type { BattleTest } from '../../types/Battle';
import type { ModelExtra, ReviewData } from '../../types/ModelInfo';
import type { Site } from '../sites/Site';

export default async (
  modelInfo: ModelExtra,
  showReviews: string,
  site: Site,
  area: string,
  battle: BattleTest | null,
  articleType?: string,
  articleCategory?: string,
  social?: string,
  trackingArea?: string,
): Promise<ReviewData[]> => {
  modelInfo = modelInfo || {};
  const reviews = Object.keys(modelInfo.reviews || {}).map((key) => modelInfo.reviews[key]);

  // Ignore reviews that don't have a reviews url HAWK-6131
  if (reviews) {
    const priorities = ((): string[] => {
      const defaultPriorities = ['asin', 'walmart'];
      const streamingScores = ['imdb', 'rt'];

      switch (showReviews) {
        case 'asin':
        case 'walmart':
          return [showReviews];
        case 'none':
          return [];
        case 'reversePriority':
          return defaultPriorities.reverse();
        case 'streamingScores':
          return streamingScores;
        default:
          return defaultPriorities;
      }
    })();
    const max = ((): number => {
      switch (showReviews) {
        case 'priority':
        case 'reversePriority':
          return 1;
        default:
          return priorities.length;
      }
    })();
    const result: ReviewData[] = [];

    for (const priority of priorities) {
      if (result.length < max) {
        /* Find the review and require the url, unless these are
        streaming reviews as we don't have a url */
        const review = reviews.find((review) => {
          if (['imdb', 'rt'].includes(review.code_name)) {
            return review.code_name === priority;
          }
          return review.code_name === priority && review.reviews_url;
        });
        if (review) {
          const customTrackingId = await getCustomTrackingId({
            site,
            area,
            articleType,
            articleCategory,
            battle,
            merchantName: review.code_name === 'asin' ? 'Amazon' : null,
          });

          review.reviews_customTrackingId = customTrackingId;

          result.push({
            ...review,
            reviews_url: getRewrittenUrl({
              url: review.reviews_url,
              site,
              customTrackingId,
              area,
              social,
              trackingArea,
            }),
          });
        }
      }
    }

    return result;
  }
  return [];
};
